interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((num) => (
        <button
          key={num}
          type="button"
          onClick={() => onChange(num)}
          className={`flex h-10 w-10 items-center justify-center rounded-md text-sm font-medium transition-colors ${
            num === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {num}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}